import { useQueryClient } from '@tanstack/react-query'

import {
  useIndividualsServiceDeleteV1IndividualsByIndividualId,
} from '../client/queries'
import {
  useUsersServiceGetV1UsersMeKey,
} from '../client/queries/common'

export const useDeleteIndividual = () => {
  const queryClient = useQueryClient()

  return useIndividualsServiceDeleteV1IndividualsByIndividualId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useUsersServiceGetV1UsersMeKey],
      })
    },
  })
}
